import React, { useState, useEffect, useRef, useCallback } from "react";
import { Paper, Container } from "@mui/material";
import Grid from "@mui/material/Grid";
import { SelectorHonorario } from "./SelectorHonorario";
import { VariablesHonorario } from "./VariablesHonorario";
import axios from "axios";
import { farmageo_api } from "../../../../config";
import HonorarioResultados from "./HonorarioResultados";
import { useLocation, useHistory } from "react-router";

import { requestErrorHandler } from "../../context/FuncionesContext";

export function ModuloHonorarios({ configuracion }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const initialAnio =
    parseInt(params.get("anio")) || configuracion.tbl_honorarios.anio;

  const initialMes =
    parseInt(
      configuracion.meses.find(
        (m) => m.nombre.toLowerCase() === params.get("mes")?.toLowerCase()
      )?.id
    ) || configuracion.tbl_honorarios.id_mes;

  const initialSindicato =
    parseInt(
      configuracion.sindicatos.find(
        (s) => s.nombre.toLowerCase() === params.get("sindicato")?.toLowerCase()
      )?.id
    ) || configuracion.tbl_honorarios.id_honorario_sindicato;

  const initialCategoria =
    configuracion.tbl_honorarios.categorias.find(
      (c) =>
        c.nombre.toLowerCase() === (params.get("categoria") ?? "").toLowerCase()
    )?.id ?? configuracion.tbl_honorarios.id_honorario_categoria;

  return (
    <ModuloHonorariosInner
      configuracion={configuracion}
      initialAnio={initialAnio}
      initialMes={initialMes}
      initialSindicato={initialSindicato}
      initialCategoria={initialCategoria}
    />
  );
}

function ModuloHonorariosInner({
  configuracion,
  initialAnio,
  initialMes,
  initialSindicato,
  initialCategoria,
}) {
  const { tbl_honorarios } = configuracion;
  const history = useHistory();
  const location = useLocation();

  const [anio, setAnio] = useState(initialAnio ?? new Date().getFullYear());
  const [mes, setMes] = useState(initialMes ?? new Date().getMonth() + 1);
  const [sindicato, setSindicato] = useState(initialSindicato ?? null);
  const [categoria, setCategoria] = useState(initialCategoria ?? -2);

  const [atributosValores, setAtributosValores] = useState({});

  const [atributos, setAtributos] = useState(configuracion.atributos);

  const [resultado, setResultado] = useState([]);
  const [totales, setTotales] = useState({});
  const [neto, setNeto] = useState(0);

  const sindicatos = configuracion.sindicatos ?? [];

  const [categorias, setCategorias] = useState(
    tbl_honorarios?.categorias ?? []
  );

  const meses = configuracion.meses ?? [];
  const anios = configuracion.anios ?? [];

  const isFirstRender = useRef(true);

  function sonArraysIgualesPorId(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;

    const ids1 = arr1.map((obj) => obj.id).sort();
    const ids2 = arr2.map((obj) => obj.id).sort();

    for (let i = 0; i < ids1.length; i++) {
      if (ids1[i] !== ids2[i]) {
        return false;
      }
    }

    return true;
  }

  const calcularHonorarios = useCallback(
    async ({ anio, mes, sindicato, categoria, atributosValores }) => {
      try {
        const res = await axios.post(
          farmageo_api + "/honorarios/calcularHonorarios",
          {
            anio,
            mes,
            sindicato,
            categoria,
            atributosValores,
          }
        );

        // if (res.request.status === 440){

        // }
        //   requestErrorHandler(res.response);
        setResultado(res.data.resultados); // ajustá según tu estructura
        setTotales(res.data.totales);
        setNeto(res.data.neto);
        if (!res.data) return; // throw new Error("No Honorario");
      } catch (err) {
        console.warn("Error al cargar honorarios:", err);
        setResultado([]);
        setTotales({});
        setNeto(0);
      }
    },
    []
  );

  function handleActualizar() {
    calcularHonorarios({
      anio,
      mes,
      sindicato,
      categoria,
      atributosValores,
    });
  }

  const getHonorario = async ({
    sindicato_arg = sindicato,
    anio_arg = anio,
    mes_arg = mes,
    categoria_arg = categoria,
  }) => {
    const res = await axios.post(farmageo_api + "/honorarios/getHonorario", {
      anio: anio_arg,
      mes: mes_arg,
      sindicato: sindicato_arg,
      categoria: categoria_arg,
    });
    return res.data;
  };

  const setHonorario = async (honorario) => {
    try {
      setAtributos(honorario.atributos); // ajustá según tu estructura

      if (
        !sonArraysIgualesPorId(categorias, honorario.tbl_honorarios.categorias)
      ) {
        setCategorias(honorario.tbl_honorarios.categorias);
        if (
          !honorario.tbl_honorarios.categorias.some((c) => c.id === categoria)
        ) {
          setCategoria(-2);
        }
      }
      if (honorario.tbl_honorarios.id_honorario_sindicato !== sindicato) {
        setSindicato(honorario.tbl_honorarios.id_honorario_sindicato);
      }
    } catch (err) {
      console.error("Error al cargar honorarios:", err);
      requestErrorHandler(err);
    }
  };

  const setParametrosUrl = () => {
    try {
      const params = new URLSearchParams();

      if (anio !== undefined) params.set("anio", anio.toString());

      const mesNombre = meses.find((m) => m.id === mes)?.nombre;
      if (mesNombre) params.set("mes", mesNombre);

      const sindicatoNombre = sindicatos.find(
        (s) => s.id === sindicato
      )?.nombre;
      if (sindicatoNombre) params.set("sindicato", sindicatoNombre);

      const categoriaNombre = categorias.find(
        (c) => c.id === categoria
      )?.nombre;
      if (categoriaNombre) params.set("categoria", categoriaNombre);

      history.push(`?${params.toString()}`);
    } catch (err) {
      console.error("Error al cargar honorarios:", err);
      requestErrorHandler(err);
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (!anio || !mes || !sindicato || !categoria) return;
    const fecthHonorario = async () => {
      const honorario = await getHonorario({});
      setHonorario(honorario);
    };
    fecthHonorario();
    setParametrosUrl();
  }, [anio, mes, categoria, categorias, meses, sindicatos, history]);

  const handleSindicatoChange = async (sindicatiId) => {
    const honorario = await getHonorario({ sindicato_arg: sindicatiId });
    setHonorario(honorario);
    setAtributos(honorario.atributos);
    setResultado(honorario.resultados); // ajustá según tu estructura
    setTotales(honorario.totales);
    setNeto(honorario.neto);
  };

  useEffect(() => {
    if (
      !anio ||
      anio < 0 ||
      !mes ||
      mes < 0 ||
      !sindicato ||
      sindicato < 0 ||
      !categoria ||
      categoria < 0
    )
      return;
    calcularHonorarios({
      anio,
      mes,
      sindicato,
      categoria,
      atributosValores,
    });
  }, [anio, atributosValores, calcularHonorarios, categoria, mes, sindicato]);

  useEffect(() => {
    if (!atributos) return;

    setAtributosValores((prev) => {
      // 1) Construyo el set de ids válidos
      const validIds = new Set(atributos.inputs.map((input) => input.id_a));

      // 2) Empiezo por copiar sólo las keys de prev que sigan siendo válidas
      const next = {};
      for (const [key, value] of Object.entries(prev)) {
        if (validIds.has(key)) {
          next[key] = value;
        }
      }

      // 3) Añado/inicializo las keys que falten según atributos.inputs
      atributos.inputs.forEach((input) => {
        const id = input.id_a;
        if (!(id in next)) {
          const rawDefault = input.es_select
            ? input.opciones?.[0]?.value ?? input.valor_default
            : input.valor_default;
          next[id] = Number(rawDefault);
        }
      });

      return next;
    });
  }, [atributos, setAtributosValores]);

  useEffect(() => {
    const updatedParams = new URLSearchParams(location.search);

    const updatedAnio = parseInt(updatedParams.get("anio")) || anio;
    const updatedMes =
      configuracion.meses.find((m) => m.nombre === updatedParams.get("mes"))
        ?.id || mes;
    const updatedSindicato =
      configuracion.sindicatos.find(
        (s) =>
          s.nombre.toLowerCase() ===
          updatedParams.get("sindicato")?.toLowerCase()
      )?.id || sindicato;
    const updatedCategoria =
      configuracion.tbl_honorarios.categorias.find(
        (c) =>
          c.nombre.toLowerCase() ===
          updatedParams.get("categoria")?.toLowerCase()
      )?.id || categoria;

    setAnio(updatedAnio);
    setMes(updatedMes);
    setSindicato(updatedSindicato);
    setCategoria(updatedCategoria);
  }, [location.search]);

  return (
    <Paper elevation={3} style={{ margin: "1.5rem 0.25rem 1.5rem 0" }}>
      <Container style={{ padding: "0.8rem" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SelectorHonorario
              anios={anios}
              anio={anio}
              setAnio={setAnio}
              sindicatos={sindicatos}
              sindicato={sindicato}
              setSindicato={handleSindicatoChange}
              meses={meses}
              mes={mes}
              setMes={setMes}
              setCategoria={setCategoria}
              categoria={categoria}
              categorias={categorias}
            />
          </Grid>
          <Grid item xs={12}>
            <VariablesHonorario
              atributos={atributos}
              setAtributosValores={setAtributosValores}
              atributosValores={atributosValores}
              handleActualizar={handleActualizar}
            />
          </Grid>
          <Grid item xs={12}>
            {resultado ? (
              <HonorarioResultados
                rows={resultado}
                totales={totales}
                neto={neto}
              />
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </Container>
    </Paper>
  );
}
